import api from "./api";

export const partnerService = {
  getAll: (filters = {}) => api.get("/partners", { params: filters }).then((res) => res.data),
  getMe: () => api.get("/partners/me").then((res) => res.data),
  getById: (id) => api.get(`/partners/${id}`).then((res) => res.data),
  create: (data) => api.post("/partners", data).then((res) => res.data),
  update: (id, data) => api.put(`/partners/${id}`, data).then((res) => res.data),
  delete: (id) => api.delete(`/partners/${id}`).then((res) => res.data),
  addRevenue: (id, data) => api.post(`/partners/${id}/revenue`, data).then((res) => res.data),
  updateRevenue: (id, entryId, data) => api.put(`/partners/${id}/revenue/${entryId}`, data).then((res) => res.data),
  getBilling: (id) => api.get(`/partners/${id}/billing`).then((res) => res.data),
  getProspects: (filters = {}) => api.get("/partners/prospects", { params: filters }).then((res) => res.data),
  getProspect: (id) => api.get(`/partners/prospects/${id}`).then((res) => res.data),
  createProspect: (data) => api.post("/partners/prospects", data).then((res) => res.data),
  updateProspect: (id, data) => api.put(`/partners/prospects/${id}`, data).then((res) => res.data),
  deleteProspect: (id) => api.delete(`/partners/prospects/${id}`).then((res) => res.data),
  convertProspect: (id) => api.post(`/partners/prospects/${id}/convert`).then((res) => res.data),
};
